module.exports = __webpack_public_path__ + "img/activity-icon.29b354f1.svg";